import { addTranslation } from '../../../../_helpers/Translate';

addTranslation({
  ru: {
    kindergarten_reestr_search_label: 'Поиск по названию',
  },
  kk: {
    kindergarten_reestr_search_label: 'Ұйым атауы бойынша іздеу',
  }
});
